// Mappa: nome del paese in lingua locale (endonimo) → simbolo della valuta nazionale.
// Per scritture non-latine si usa la grafia nativa. "-" se valuta sconosciuta / non applicabile.
export const COUNTRIES = {
    "Afġānistān": "؋",
    "Shqipëria": "L",
    "الجزائر": "DA",
    "Andorra": "€",
    "Angola": "Kz",
    "Anguilla": "EC$",
    "Antarctica": "-",
    "Antigua and Barbuda": "EC$",
    "Nederlandse Antillen": "-",
    "المملكة العربية السعودية": "﷼",
    "Argentina": "$",
    "Հայաստան": "֏",
    "Aruba": "ƒ",
    "Australia": "$",
    "Österreich": "€",
    "Azərbaycan": "₼",
    "Bahamas": "$",
    "البحرين": "BD",
    "বাংলাদেশ": "৳",
    "Barbados": "$",
    "België": "€",
    "Belize": "$",
    "Bénin": "CFA",
    "Bermuda": "$",
    "Беларусь": "Br",
    "འབྲུག་ཡུལ": "Nu",
    "Bolivia": "Bs",
    "Bosna i Hercegovina": "KM",
    "Botswana": "P",
    "Brasil": "R$",
    "Brunei Darussalam": "$",
    "България": "лв",
    "Burkina Faso": "CFA",
    "Burundi": "FBu",
    "កម្ពុជា": "៛",
    "Cameroun": "CFA",
    "Canada": "$",
    "Cabo Verde": "$",
    "Tchad": "CFA",
    "Chile": "$",
    "中国": "¥",
    "Κύπρος": "€",
    "Stato della Città del Vaticano": "€",
    "Colombia": "$",
    "Comores": "CF",
    "조선민주주의인민공화국": "₩",
    "대한민국": "₩",
    "Costa Rica": "₡",
    "Côte d'Ivoire": "CFA",
    "Hrvatska": "€",
    "Cuba": "$",
    "Danmark": "kr",
    "Dominica": "EC$",
    "Ecuador": "$",
    "مصر": "£",
    "Éire": "€",
    "El Salvador": "$",
    "الإمارات العربية المتحدة": "د.إ",
    "Eritrea": "Nfk",
    "Eesti": "€",
    "ኢትዮጵያ": "Br",
    "Россия": "₽",
    "Fiji": "$",
    "Pilipinas": "₱",
    "Suomi": "€",
    "France": "€",
    "Gabon": "CFA",
    "Gambia": "D",
    "საქართველო": "₾",
    "Deutschland": "€",
    "Ghana": "₵",
    "Jamaica": "$",
    "日本": "¥",
    "Gibraltar": "£",
    "Djibouti": "Fdj",
    "الأردن": "JD",
    "Ελλάδα": "€",
    "Grenada": "EC$",
    "Kalaallit Nunaat": "kr",
    "Guadeloupe": "€",
    "Guam": "$",
    "Guatemala": "Q",
    "Guinée": "FG",
    "Guiné-Bissau": "CFA",
    "Guinea Ecuatorial": "CFA",
    "Guyana": "$",
    "Guyane française": "€",
    "Ayiti": "G",
    "Honduras": "L",
    "香港": "HK$",
    "भारत": "₹",
    "Indonesia": "Rp",
    "ایران": "﷼",
    "العراق": "ع.د",
    "Bouvetøya": "kr",
    "Christmas Island": "$",
    "Heard and McDonald Islands": "$",
    "Cayman Islands": "$",
    "Cocos Islands": "$",
    "Cook Islands": "$",
    "Falkland Islands": "£",
    "Føroyar": "kr",
    "Aolepān Aorōkin Ṃajeḷ": "$",
    "Northern Mariana Islands": "$",
    "United States Minor Outlying Islands": "$",
    "Norfolk Island": "$",
    "Solomon Islands": "$",
    "Turks and Caicos Islands": "$",
    "United States Virgin Islands": "$",
    "British Virgin Islands": "$",
    "ישראל": "₪",
    "Ísland": "kr",
    "Italia": "€",
    "Қазақстан": "₸",
    "Kenya": "KSh",
    "Кыргызстан": "с",
    "Kiribati": "$",
    "الكويت": "د.ك",
    "ລາວ": "₭",
    "Latvija": "€",
    "Lesotho": "L",
    "لبنان": "ل.ل",
    "Liberia": "$",
    "ليبيا": "د.ل",
    "Liechtenstein": "CHF",
    "Lietuva": "€",
    "Lëtzebuerg": "€",
    "澳門": "MOP$",
    "Северна Македонија": "ден",
    "Madagasikara": "Ar",
    "Malawi": "MK",
    "Dhivehi Raajje": "Rf",
    "Malaysia": "RM",
    "Mali": "CFA",
    "Malta": "€",
    "المغرب": "د.م.",
    "Martinique": "€",
    "موريتانيا": "UM",
    "Mauritius": "₨",
    "Mayotte": "€",
    "México": "$",
    "Moldova": "L",
    "Monaco": "€",
    "Монгол": "₮",
    "Montserrat": "EC$",
    "Moçambique": "MT",
    "မြန်မာ": "K",
    "Namibia": "$",
    "Nauru": "$",
    "नेपाल": "₨",
    "Nicaragua": "C$",
    "Niger": "CFA",
    "Nigeria": "₦",
    "Niue": "$",
    "Norge": "kr",
    "Nouvelle-Calédonie": "₣",
    "New Zealand": "$",
    "عُمان": "ر.ع.",
    "Nederland": "€",
    "پاکستان": "₨",
    "Belau": "$",
    "Panamá": "B/.",
    "Papua New Guinea": "K",
    "Paraguay": "₲",
    "Perú": "S/.",
    "Pitcairn": "$",
    "Polynésie française": "₣",
    "Polska": "zł",
    "Portugal": "€",
    "Puerto Rico": "$",
    "قطر": "ر.ق",
    "United Kingdom": "£",
    "Česko": "Kč",
    "République centrafricaine": "CFA",
    "République du Congo": "CFA",
    "République démocratique du Congo": "FC",
    "República Dominicana": "$",
    "La Réunion": "€",
    "România": "lei",
    "Rwanda": "FRw",
    "الصحراء الغربية": "-",
    "Saint Kitts and Nevis": "EC$",
    "Saint-Pierre-et-Miquelon": "€",
    "Saint Vincent and the Grenadines": "EC$",
    "Sāmoa": "$",
    "American Samoa": "$",
    "San Marino": "€",
    "Saint Helena": "£",
    "Saint Lucia": "EC$",
    "São Tomé e Príncipe": "Db",
    "Sénégal": "CFA",
    "Srbija i Crna Gora": "-",
    "Sesel": "₨",
    "Sierra Leone": "Le",
    "Singapore": "$",
    "سوريا": "£",
    "Slovensko": "€",
    "Slovenija": "€",
    "Soomaaliya": "Sh",
    "España": "€",
    "ශ්‍රී ලංකා": "₨",
    "Federated States of Micronesia": "$",
    "United States of America": "$",
    "South Africa": "R",
    "South Georgia and the South Sandwich Islands": "£",
    "السودان": "ج.س",
    "Suriname": "$",
    "Svalbard og Jan Mayen": "kr",
    "Sverige": "kr",
    "Schweiz": "CHF",
    "Eswatini": "L",
    "Тоҷикистон": "SM",
    "ประเทศไทย": "฿",
    "臺灣": "NT$",
    "Tanzania": "TSh",
    "British Indian Ocean Territory": "$",
    "Terres australes françaises": "€",
    "فلسطين": "₪",
    "Timor-Leste": "$",
    "Togo": "CFA",
    "Tokelau": "$",
    "Tonga": "T$",
    "Trinidad and Tobago": "$",
    "تونس": "د.ت",
    "Türkiye": "₺",
    "Türkmenistan": "T",
    "Tuvalu": "$",
    "Україна": "₴",
    "Uganda": "USh",
    "Magyarország": "Ft",
    "Uruguay": "$",
    "Oʻzbekiston": "soʻm",
    "Vanuatu": "VT",
    "Venezuela": "Bs",
    "Việt Nam": "₫",
    "Wallis et Futuna": "₣",
    "اليمن": "﷼",
    "Zambia": "K",
    "Zimbabwe": "$"
};


export const CUSTOMER_CURRENCY = [
    "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN",
    "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD",
    "CAD", "CDF", "CHF", "CLP", "CNY", "COP", "CRC", "CUP", "CVE", "CZK",
    "DJF", "DKK", "DOP", "DZD",
    "EGP", "ERN", "ETB", "EUR",
    "FJD", "FKP",
    "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD",
    "HKD", "HNL", "HTG", "HUF",
    "IDR", "ILS", "INR", "IQD", "IRR", "ISK",
    "JMD", "JOD", "JPY",
    "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT",
    "LAK", "LBP", "LKR", "LRD", "LSL", "LYD",
    "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN",
    "NAD", "NGN", "NIO", "NOK", "NPR", "NZD",
    "OMR",
    "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG",
    "QAR",
    "RON", "RSD", "RUB", "RWF",
    "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL",
    "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS",
    "UAH", "UGX", "USD", "UYU", "UZS",
    "VED", "VES", "VND", "VUV",
    "WST",
    "XAF", "XCD", "XDR", "XOF", "XPF",
    "YER",
    "ZAR", "ZMW", "ZWG", "ZWL",
];


// Mappa: stessa chiave di COUNTRIES (endonimo del paese) → codice valuta ISO 4217.
// Le chiavi devono restare allineate a quelle di COUNTRIES.
// Tutti i codici appartengono a CUSTOMER_CURRENCY. null dove non esiste una valuta ISO (es. Antartide).
export const COUNTRY_CURRENCY_CODE = {
    "Afġānistān": "AFN",
    "Shqipëria": "ALL",
    "الجزائر": "DZD",
    "Andorra": "EUR",
    "Angola": "AOA",
    "Anguilla": "XCD",
    "Antarctica": null,
    "Antigua and Barbuda": "XCD",
    "Nederlandse Antillen": "ANG",
    "المملكة العربية السعودية": "SAR",
    "Argentina": "ARS",
    "Հայաստան": "AMD",
    "Aruba": "AWG",
    "Australia": "AUD",
    "Österreich": "EUR",
    "Azərbaycan": "AZN",
    "Bahamas": "BSD",
    "البحرين": "BHD",
    "বাংলাদেশ": "BDT",
    "Barbados": "BBD",
    "België": "EUR",
    "Belize": "BZD",
    "Bénin": "XOF",
    "Bermuda": "BMD",
    "Беларусь": "BYN",
    "འབྲུག་ཡུལ": "BTN",
    "Bolivia": "BOB",
    "Bosna i Hercegovina": "BAM",
    "Botswana": "BWP",
    "Brasil": "BRL",
    "Brunei Darussalam": "BND",
    "България": "BGN",
    "Burkina Faso": "XOF",
    "Burundi": "BIF",
    "កម្ពុជា": "KHR",
    "Cameroun": "XAF",
    "Canada": "CAD",
    "Cabo Verde": "CVE",
    "Tchad": "XAF",
    "Chile": "CLP",
    "中国": "CNY",
    "Κύπρος": "EUR",
    "Stato della Città del Vaticano": "EUR",
    "Colombia": "COP",
    "Comores": "KMF",
    "조선민주주의인민공화국": "KPW",
    "대한민국": "KRW",
    "Costa Rica": "CRC",
    "Côte d'Ivoire": "XOF",
    "Hrvatska": "EUR",
    "Cuba": "CUP",
    "Danmark": "DKK",
    "Dominica": "XCD",
    "Ecuador": "USD",
    "مصر": "EGP",
    "Éire": "EUR",
    "El Salvador": "USD",
    "الإمارات العربية المتحدة": "AED",
    "Eritrea": "ERN",
    "Eesti": "EUR",
    "ኢትዮጵያ": "ETB",
    "Россия": "RUB",
    "Fiji": "FJD",
    "Pilipinas": "PHP",
    "Suomi": "EUR",
    "France": "EUR",
    "Gabon": "XAF",
    "Gambia": "GMD",
    "საქართველო": "GEL",
    "Deutschland": "EUR",
    "Ghana": "GHS",
    "Jamaica": "JMD",
    "日本": "JPY",
    "Gibraltar": "GIP",
    "Djibouti": "DJF",
    "الأردن": "JOD",
    "Ελλάδα": "EUR",
    "Grenada": "XCD",
    "Kalaallit Nunaat": "DKK",
    "Guadeloupe": "EUR",
    "Guam": "USD",
    "Guatemala": "GTQ",
    "Guinée": "GNF",
    "Guiné-Bissau": "XOF",
    "Guinea Ecuatorial": "XAF",
    "Guyana": "GYD",
    "Guyane française": "EUR",
    "Ayiti": "HTG",
    "Honduras": "HNL",
    "香港": "HKD",
    "भारत": "INR",
    "Indonesia": "IDR",
    "ایران": "IRR",
    "العراق": "IQD",
    "Bouvetøya": "NOK",
    "Christmas Island": "AUD",
    "Heard and McDonald Islands": "AUD",
    "Cayman Islands": "KYD",
    "Cocos Islands": "AUD",
    "Cook Islands": "NZD",
    "Falkland Islands": "FKP",
    "Føroyar": "DKK",
    "Aolepān Aorōkin Ṃajeḷ": "USD",
    "Northern Mariana Islands": "USD",
    "United States Minor Outlying Islands": "USD",
    "Norfolk Island": "AUD",
    "Solomon Islands": "SBD",
    "Turks and Caicos Islands": "USD",
    "United States Virgin Islands": "USD",
    "British Virgin Islands": "USD",
    "ישראל": "ILS",
    "Ísland": "ISK",
    "Italia": "EUR",
    "Қазақстан": "KZT",
    "Kenya": "KES",
    "Кыргызстан": "KGS",
    "Kiribati": "AUD",
    "الكويت": "KWD",
    "ລາວ": "LAK",
    "Latvija": "EUR",
    "Lesotho": "LSL",
    "لبنان": "LBP",
    "Liberia": "LRD",
    "ليبيا": "LYD",
    "Liechtenstein": "CHF",
    "Lietuva": "EUR",
    "Lëtzebuerg": "EUR",
    "澳門": "MOP",
    "Северна Македонија": "MKD",
    "Madagasikara": "MGA",
    "Malawi": "MWK",
    "Dhivehi Raajje": "MVR",
    "Malaysia": "MYR",
    "Mali": "XOF",
    "Malta": "EUR",
    "المغرب": "MAD",
    "Martinique": "EUR",
    "موريتانيا": "MRU",
    "Mauritius": "MUR",
    "Mayotte": "EUR",
    "México": "MXN",
    "Moldova": "MDL",
    "Monaco": "EUR",
    "Монгол": "MNT",
    "Montserrat": "XCD",
    "Moçambique": "MZN",
    "မြန်မာ": "MMK",
    "Namibia": "NAD",
    "Nauru": "AUD",
    "नेपाल": "NPR",
    "Nicaragua": "NIO",
    "Niger": "XOF",
    "Nigeria": "NGN",
    "Niue": "NZD",
    "Norge": "NOK",
    "Nouvelle-Calédonie": "XPF",
    "New Zealand": "NZD",
    "عُمان": "OMR",
    "Nederland": "EUR",
    "پاکستان": "PKR",
    "Belau": "USD",
    "Panamá": "PAB",
    "Papua New Guinea": "PGK",
    "Paraguay": "PYG",
    "Perú": "PEN",
    "Pitcairn": "NZD",
    "Polynésie française": "XPF",
    "Polska": "PLN",
    "Portugal": "EUR",
    "Puerto Rico": "USD",
    "قطر": "QAR",
    "United Kingdom": "GBP",
    "Česko": "CZK",
    "République centrafricaine": "XAF",
    "République du Congo": "XAF",
    "République démocratique du Congo": "CDF",
    "República Dominicana": "DOP",
    "La Réunion": "EUR",
    "România": "RON",
    "Rwanda": "RWF",
    "الصحراء الغربية": "MAD",
    "Saint Kitts and Nevis": "XCD",
    "Saint-Pierre-et-Miquelon": "EUR",
    "Saint Vincent and the Grenadines": "XCD",
    "Sāmoa": "WST",
    "American Samoa": "USD",
    "San Marino": "EUR",
    "Saint Helena": "SHP",
    "Saint Lucia": "XCD",
    "São Tomé e Príncipe": "STN",
    "Sénégal": "XOF",
    "Srbija i Crna Gora": "RSD",
    "Sesel": "SCR",
    "Sierra Leone": "SLE",
    "Singapore": "SGD",
    "سوريا": "SYP",
    "Slovensko": "EUR",
    "Slovenija": "EUR",
    "Soomaaliya": "SOS",
    "España": "EUR",
    "ශ්‍රී ලංකා": "LKR",
    "Federated States of Micronesia": "USD",
    "United States of America": "USD",
    "South Africa": "ZAR",
    "South Georgia and the South Sandwich Islands": "GBP",
    "السودان": "SDG",
    "Suriname": "SRD",
    "Svalbard og Jan Mayen": "NOK",
    "Sverige": "SEK",
    "Schweiz": "CHF",
    "Eswatini": "SZL",
    "Тоҷикистон": "TJS",
    "ประเทศไทย": "THB",
    "臺灣": "TWD",
    "Tanzania": "TZS",
    "British Indian Ocean Territory": "USD",
    "Terres australes françaises": "EUR",
    "فلسطين": "ILS",
    "Timor-Leste": "USD",
    "Togo": "XOF",
    "Tokelau": "NZD",
    "Tonga": "TOP",
    "Trinidad and Tobago": "TTD",
    "تونس": "TND",
    "Türkiye": "TRY",
    "Türkmenistan": "TMT",
    "Tuvalu": "AUD",
    "Україна": "UAH",
    "Uganda": "UGX",
    "Magyarország": "HUF",
    "Uruguay": "UYU",
    "Oʻzbekiston": "UZS",
    "Vanuatu": "VUV",
    "Venezuela": "VES",
    "Việt Nam": "VND",
    "Wallis et Futuna": "XPF",
    "اليمن": "YER",
    "Zambia": "ZMW",
    "Zimbabwe": "ZWG"
};


/**
 * Dato il nome di un paese (chiave di COUNTRIES), ritorna il codice valuta ISO 4217 di quel paese.
 * @param {string} country chiave di COUNTRIES, es. "Italia"
 * @returns {string|null} codice ISO 4217 (es. "EUR"), oppure null se il paese non è mappato
 *                         o non ha una valuta ISO applicabile (es. "Antarctica").
 */
export function getCurrencyByCountry(country) {
    return COUNTRY_CURRENCY_CODE[country] || null;
}


export function formatMoney(value, currency) {
    const amount = Number(value) || 0;
    const locale = ((this.$i18n && this.$i18n.locale) || "en").replace("_", "-");
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency
        }).format(amount);
    } catch (e) {
        // codice valuta non riconosciuto da Intl: fallback "1.234,56 XXX"
        const num = new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
        return num + " " + (currency || "");
    }
}